import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-timeclock",
  "use": "icon-timeclock-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-timeclock\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 1024a512 512 0 1 1 512-512 512 512 0 0 1-512 512z m204.8-512h-179.2V256a51.2 51.2 0 0 0-102.4 0v307.2a51.2 51.2 0 0 0 51.2 51.2h230.4a51.2 51.2 0 0 0 0-102.4z\" fill=\"#ffffff\" p-id=\"6067\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol